import React from "react";
import { SiTicktick } from "react-icons/si";
import Button from "../../components/Constant/button/Button";
import "./IntroSection.css";

const IntroSection = ({
                          title,
                          subtitle,
                          description,
                          badges = [],
                          listTitle,
                          listSubtitle,
                          listItems = [], // array of items for the single list
                          buttonText,
                          buttonLink,
                          imageSrc,
                          imageAlt
                      }) => {
    return (
        <div className="intro-container">
            <div className="intro-section section container">
                <div className="intro-content">
                    <h1 className="intro-title">{title}</h1>
                    <p className="intro-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
                    <p className="intro-description" dangerouslySetInnerHTML={{ __html: description }} />

                    {/* Single List */}
                    {Array.isArray(listItems) && listItems.length > 0 && (
                        <div className="intro-list-wrapper">
                            {listTitle && <h3 className="intro-list-title">{listTitle}</h3>}
                            {listSubtitle && <p className="intro-list-subtitle">{listSubtitle}</p>}
                            <ul className="intro-list">
                                {listItems.map((item, i) => (
                                    <li key={i}>
                                        <SiTicktick className="intro-list-icon" /> {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div className="intro-badges">
                        {Array.isArray(badges) && badges.map((badge, i) => (
                            <span key={i} className="intro-badge">
                                <SiTicktick className="intro-badge-icon" /> {badge}
                            </span>
                        ))}
                    </div>

                    {buttonText && buttonLink && (
                        <Button size="large" link={buttonLink} text={buttonText} />
                    )}
                </div>

                <div className="intro-image-wrapper">
                    <img className="intro-image" src={imageSrc} alt={imageAlt} />
                </div>
            </div>
        </div>
    );
};

export default IntroSection;
